import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useDeviceType } from '../../../responsive';
import { SuggestMobile } from '../SuggestMobile';
import { SuggestDesktop } from '../SuggestDesktop';

/**
 * [Ссылка на макет](https://www.figma.com/design/4UM8zoowH9YGMM7fSK0rhD/%F0%9F%8C%90-Web-Components?node-id=42779-31352&t=dWJSsCGr4smKrzpW-4)
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const Suggest = props => {
  const deviceType = useDeviceType();
  const AdaptiveComponent = {
    phone: SuggestMobile,
    tablet: SuggestMobile,
    desktop: SuggestDesktop
  }[deviceType];
  return /*#__PURE__*/_jsx(AdaptiveComponent, _objectSpread({}, props));
};